import { useId } from 'react';

/**
 * Per-instance prefix for ids inside an inline-rendered SVG.
 *
 * SVG assets are inlined, so two copies of the same icon on one screen put two
 * elements with the same id in the document and `url(#id)` resolves to the
 * first one — which renders blank/black once that copy is hidden (TA-9882,
 * TA-10058). Prefixing every id with this value makes each instance's ids
 * unique. `useId()` output contains characters (`:`, `«`, `»`) that are not
 * safe inside `url(#…)` references, so it is reduced to `[A-Za-z0-9_-]`.
 */
export const useSvgIdPrefix = (): string => useId().replace(/[^\w-]/g, '');
